import { UseAuth, UserContext } from "/@/contexts";
import { RouterProvider } from "react-router-dom";
import { router } from "/@/router";
import { joinSocketRoom } from "@jasper/shared";
import { useEffect } from "react";
import { FormsProvider } from "@jasper/forms";
import i18next from "i18next";
import { ProductWorkflowsProvider } from "@jasper/product-workflows";

const App = () => {
  const { user, identifyUser } = UseAuth();

  useEffect(() => {
    if (user) identifyUser(user);
  }, [user]);

  useEffect(() => joinSocketRoom("notification"), []);

  return (
    <FormsProvider i18n={i18next}>
      <UserContext.Provider value={{ user }}>
        <ProductWorkflowsProvider i18n={i18next}>
          <RouterProvider router={router} />
        </ProductWorkflowsProvider>
      </UserContext.Provider>
    </FormsProvider>
  );
};

export default App;
